import {
  Dialog,
  DialogClose,
  DialogContent,
} from "@/components/ui/dialoglogin";
import { Step2 } from "./Step2";

interface RestDialogProps {
  isOpen: boolean;
  email: string;
  token: string;
  onClose: () => void;
}

const RestDialog = ({ isOpen, email, token, onClose }: RestDialogProps) => {
  return (
    <Dialog open={isOpen}>
      <DialogContent
        className={`max-h-screen bg-[url('/login/login-back.png')] bg-cover text-white/30 md:min-w-[636px]`}
        onClose={onClose}
      >
        <Step2 email={email} token={token} onSave={onClose} />
      </DialogContent>
    </Dialog>
  );
};

export default RestDialog;
